<template>
    <main>
        <crumbs :crumbs="crumbs"></crumbs>
		<div class="wrap">
			<div class="s1">
				<div class="center">
					<div class="left info">
						<div class="title">{{adv1.title}}</div>
						<div class="line"></div>
						<div class="element-more desc">{{adv1.desc}}</div>
						<div class="btn" @click="util.toLink(adv1.link,'','_blank')" v-if="adv1.link">查看更多</div>
					</div>
					<div class="right video-box">
						<video controls preload="auto" id="s1_video" loop v-if="adv1.video" :poster="adv1.image ? util.autoImage(adv1.image) : util.autoImage(adv1.video)+'?x-oss-process=video/snapshot,t_0,f_jpg,m_fast'" >
							<source :src="util.autoImage(adv1.video)" >
						</video>
						<div class="mark" v-if="s1_play_show">
							<div class="play" @click="playVideo"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="s2">
				<div class="center">
					<div class="title">{{adv2.title}}</div>
					<div class="line"></div>
					<div class="info-box" v-for="(item,index) in adv4">
						<div class="left image" :style="{backgroundImage:'url('+item.image+')'}"></div>
						<div class="right info">
							<div class="element tit">{{item.title}}</div>
							<div class="element-more desc">{{item.desc}}</div>
							<div class="btn-box" v-if="item.link">
								<div class="right">
									<div class="btn" @click="showVideo(item)">观看视频</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="s3">
				<div class="center">
					<div class="list">
						<div class="left item" v-for="item in adv3" @click="toLink(item)">
							<div class="image" :style="{backgroundImage:'url('+item.image+')'}"></div>
							<div class="element title">{{item.title}}</div>
							<div class="element-more desc" :title="item.desc">{{item.desc}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        <down-load :file="file_info" v-if="file_info.file_id" @hideDownload="file_info = {}"></down-load>
		<video-float v-if="video_info.title" :video_info="video_info" @hideVideo="hideVideo"></video-float>
    </main>
</template>

<script>
import Crumbs from "../../components/pc/Crumbs";
import DownLoad from "../../components/pc/DownLoad";
import VideoFloat from "@/components/pc/VideoFloat";
export default {
	name: 'social',
	data() {
		return {
			query:"",
			s1_play_show:true,
			adv1:{
				"title":"我们的承诺：",
				"image":"https://dellvideo.smarket.net.cn/139ab54b50fa4e9d9a440725c32e8364/covers/51d38ae3ccc0487eae4d6cd57dd4934c-00005.jpg",
				"video":"https://dellvideo.smarket.net.cn/fdbaabf9855b43cbb71ecc0437806712/6607d6b094324c91b1b2e1999f403504-6ade5f17cd254e1e412314a5ee3d4d25-ld.mp4",
				"desc":"戴尔科技致力于推动人类进步。 戴尔科技希望通过自身影响力、技术和员工，努力推动社会可持续发展性、培养人类包容性，从而改变世界各地的生活，产生积极而持久的影响。 我们之所以能够产生有意义的影响，其根本在于我们对维护道德和隐私的持久承诺。",
				"link":"https://corporate.delltechnologies.com/en-us/social-impact.htm",
			},
			adv2:{
				"title":"致力共赢发展",
				"min_title":"教育重点领域：面向未来",
				"image":require('@/assets/image/u2.jpg'),
				"desc":"目前来讲，面向职业教育和偏远地区学生的数字素养教育至关重要，但教育贫困（学习资源不足）对农村地区学生和职业教育课程的影响尤为严重，如何解决这一问题呢？其一可通过ICDL国际计算机素养许可计划进行职业培训，其二为远程教育， Mak-er编程发起了针对教师的“培训师”计划，通过Scratch平台进行编程教学。",
				"link":"https://www.cedf.org.cn/",
			},
			adv3:[
				{
					"title":"计划中的方法和原因",
					"image":require('@/assets/image/u3.jpg'),
					"desc":"戴尔科技如何确立2030年的社会影响愿景和moonshot目标？",
					"link":"https://corporate.delltechnologies.com/en-us/social-impact/reporting/2030-goals.htm",
				},
				{
					"title":"IDC的观点",
					"image":require('@/assets/image/u4.jpg'),
					"desc":"有大胆且可衡量的目标，以此探索如何推动真正的进步，实现更美好的世界。",
					"link":"",
				},
				{
					"title":"多样性与包容性：我们就是这样的人",
					"image":require('@/assets/image/u5.jpg'),
					"desc":"多样性和包容性是企业的当务之急，对戴尔科技的成功至关重要。 目前集团已经设定了一个目标，即到2030年，全球50%的员工和40%的全球员工领袖将是女性。",
					"link":"https://corporate.delltechnologies.com/en-us/social-impact/cultivating-inclusion.htm",
				},
				{
					"title":"资产转售和回收服务",
					"image":require('@/assets/image/u6.jpg'),
					"desc":"我们会处理旧的，所以你可以专注于新的。",
					"link":"https://corporate.delltechnologies.com/en-us/social-impact/advancing-sustainability.htm",
				}
			],
			adv4:[
				{
					title:"戴尔科技集团在2021年取得的社会影响进展",
					desc:"我们有能力解决世界上最大的问题，抓住最大的机会，戴尔科技集团将承担自己应尽的责任，利用技术的威力推动人类进步，我们将竭尽全力，在关键时期积极、长久的影响，而且我坚信我们能够打造一个美好的未来，和一个更加可持续的世界，我们志存高远，团结一致，我们的愿景是以数据驱动未来，一个更美好，更健康，更环保，更公平的未来。",
					image:require('@/assets/image/z1.jpg'),
					link:"https://dellvideo.smarket.net.cn/86952703dae4455f81cb7a8921c7965d/697b8da2aa2c4ceabc24e8fd0448b0c4-8c3e459ee908f6c93e312bd46b1f6775-ld.mp4"
				},
				{
					title:"太阳能学习实验室",
					desc:"我们坚信，为世界带来福祉，就是对我们最好的回报，太阳能教室的理念是在那些贫穷的缺少能源的地区消除教育鸿沟。第一座太阳能学习实验室在2014年开张，他对于戴尔科技阶段而言也是意义非凡了，它体现了我们带来的社会影响，实验中的可持续性也彰显了我们的循环经济理念，它也推动了青年一代的转变，为他们创造了良好的教育条件。",
					image:require('@/assets/image/z2.jpg'),
					link:"https://dellvideo.smarket.net.cn/b321b0c1d19f45b1bc2f1bb5b24a08d1/2651b3dc666b45c5bcc555d6963db3bb-473f7d3d08242d59bafa6144d5406f6e-ld.mp4"
				}
			],
			file_info:{},
			video_info:{},
		}
	},
	components:{
		VideoFloat,
		Crumbs,DownLoad
	},
	computed:{
		crumbs() {
			return {title:"社会责任",min_title:"SOCIAL IMPACT"}
		},
	},
	methods: {
		showVideo(item){
			item.video = item.link;
			this.video_info = item;
		},
		hideVideo(){
			this.video_info = {}
		},
		toLink(item){
			if(item.title == 'IDC的观点'){
				this.file_info = {
					file_id:"205083335"
				}
			}else{
				if(item.link){
					this.util.toLink(item.link,'','_blank');
				}
			}
		},
		playVideo(){
			var video = document.getElementById('s1_video');
			video.addEventListener('play',()=>{
				this.s1_play_show = false;
			})
			video.addEventListener('pause',()=>{
				this.s1_play_show = true;
			})
			video.play();
		},
	},
	mounted() {
		this.query = this.$route.query;
		this.util.showBottom(true);
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.wrap{background: #f6f6f6 url("~@/assets/image/2021/17.png") no-repeat bottom center;background-size: 100% auto; }
.s1{padding-top: 25px;display: none;
	.center{width: 1200px;margin: 0 auto;overflow: hidden;
		.info{background: #fff;width: 470px;height:300px; padding: 30px;color: #565656;border-radius: 5px;
			.title{font-size: 18px;line-height: 20px;}
			.line{width: 40px;height:4px;background: #3176c8;margin-top: 5px;}
			.desc{margin-top: 15px;font-size: 14px;line-height: 22px;  -webkit-line-clamp: 12;white-space: pre-line;}
			.btn{width: 130px;height:40px;text-align: center;line-height: 40px;color:#fff;background:  linear-gradient(90deg,#47ced9,#357b8f);font-size: 16px;margin: 30px auto 0;cursor: pointer;border-radius: 5px;}
		}
		.video-box{width: 640px;height:360px;position: relative;border-radius: 5px;overflow: hidden;
			video{width: 100%;height:100%;object-fit: cover;}
			.mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.5);
				.play{width: 60px;height:60px;position: absolute;top:50%;left:50%;background: url("~@/assets/image/4.png") no-repeat left center;background-size: contain;margin-left: -30px;margin-top: -30px; cursor: pointer;}
			}
		}
	}
}
.s2{padding-top: 30px;padding-bottom: 50px;
	.center{width: 1200px;margin: 0 auto;overflow: hidden;
		.title{font-size: 26px;line-height: 30px;display: none;}
		.line{width: 140px;height:4px;background: #3176c8;margin-top: 5px;display: none;}
		.info-box{margin-top:15px;overflow: hidden;height:250px;background: #fff;
			.image{width: 370px;height:250px; background-repeat: no-repeat;background-position: center center;background-size: cover;background-image: url("~@/assets/image/74.png");}
			.info{padding: 25px;width: 780px;
				.tit{font-size: 16px;font-weight: bold}
				.desc{font-size: 14px;line-height: 26px;color:#676767;margin-top: 10px; -webkit-line-clamp: 4;white-space: pre-line;}
				.btn-box{
					.right{
						.btn{width: 130px;height:40px;text-align: center;line-height: 40px;color:#fff;background:  linear-gradient(90deg,#47ced9,#357b8f);font-size: 16px;margin: 30px auto 0;cursor: pointer;border-radius: 5px;}
					}
				}
			}
		}
	}
}
.s3{padding-top: 50px;padding-bottom: 50px;display: none;
	.center{width: 1200px;margin: 0 auto;
		.list{overflow: hidden;
			.item{width: 285px;margin-right: 20px;cursor: pointer;
				.image{height:180px;background-repeat: no-repeat;background-position: center center;background-size: cover;background-image: url("~@/assets/image/75.png");}
				.title{font-size: 16px;line-height:1;margin-top: 10px;font-weight: bold;}
				.desc{font-size: 14px;line-height: 24px;color:#676767;margin-top: 10px;-webkit-line-clamp:5;white-space: pre-line;}
			}
			.item:nth-child(4n){margin-right: 0;}
		}
	}
}
</style>

